/* eslint-disable jsx-a11y/anchor-is-valid */ 
import React from "react";
import { ClientContextObject } from "../../redux";
import { Button, ButtonSize, ButtonVariant } from "@spectrumselect/mi-ui-react";
import { local } from "../../internationalization/Localization";
import { MAILTO } from "../../utils/constants";
import "./SendOTPForm.scss";

export interface SendOTPFormProps {
  targets: { title: string, value: com.ts.mobile.sdk.InputOrControlResponse<com.ts.mobile.sdk.InputResponseType>, label: string }[];
  instructions: string;
  cancelRequest?: com.ts.mobile.sdk.InputOrControlResponse<com.ts.mobile.sdk.InputResponseType>;
  clientContext: ClientContextObject;
  title?: string;
  resolve: (value: any | PromiseLike<any>) => void;
  tenant?: string;
}

export const SendOTPForm: React.FunctionComponent<SendOTPFormProps> = (props) => {

  const onCancelButtonClick = () => {
    props.cancelRequest && props.resolve(props?.cancelRequest);
  }

  const onSubmitButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    props.resolve(props.targets[0]?.value);
  }

  return (
    <form className="SendOTPForm">
      {props.title && <h1 className="App_pageTitle">Additional verification required</h1>}
      <div className="SendOTPForm_DescriptionWrapper">
        <p className="App_formDesc SendOTPForm_formDesc">For your security, we need to verify your identity. </p>
        <p className="App_formDesc SendOTPForm_formDesc">
          We will send a verification code to your account: 
        </p>
      </div>
      <p className="App_formDesc email-text">
        <span>{props.targets[0]?.title}</span>
      </p>
      {/* <div className="SendOTPForm_EmailTextContainer">
        <p className="SendOTPForm_EmailLabel">{props.targets[0]?.label}</p>
        <p className="SendOTPForm_EmailText">{props.targets[0]?.title}</p>
      </div> */}

      {props.cancelRequest &&
        <div className={"App_formButtonGroup"}>
          <a href="javascript:void(0)" className="UsernameForm_ResetPwdButton" onClick={onCancelButtonClick}>
            Sign into a different account
          </a>
          <Button
            variant={ButtonVariant.primary}
            type="submit"
            className={`login100-form-btn ${props.tenant}-btn`}
            onClick={onSubmitButtonClick}
            size={ButtonSize.large}
          >
            {local.get("buttonLabels[4]")}
          </Button>
        </div>
      }
      <p className="txt2 welcome-desc">Need more help logging in? Please contact our Onboarding Team <span>(<a href={MAILTO.link}>{MAILTO.text}</a>)</span>.</p>
    </form>
  );
}
